// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"a2046028","350":"21ba4e10","533":"e0b56aee","721":"001d0194","786":"9844cae4","925":"a7f2d12b"}[chunkId] + ".css";
};